import {MenuVoice} from "./MenuVoice";

export class MenuGroup {
  /**
   * id
   */
  id!: number;
  /**
   * Name of the menu group
   */
  name!: string;
  /**
   * Enabled roles
   * Empty -> all roles
   */
  roles!: string[];
  /**
   * OrderIndex
   */
  orderIndex!: number;
  /**
   * icon
   */
  voices!: MenuVoice[];

  isOpen = true;

  constructor() {
    this.voices = new Array<MenuVoice>();
  }
}
